export const BASA_DOCUMENT_ROUTE_PREFIX = "/basa";
export const BASA_DOCUMENT_PATH_PATTERN = /^\/basa\/([A-Za-z0-9]{2,10})\/(\d{1,12})\/?$/;
